import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { formatDate } from "../../functions/formatDate";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Visibility } from "@mui/icons-material";
import FormularEingabe from "./FormularEingabe";
import CloseIcon from "@mui/icons-material/Close";
import { VisibilityOff } from "@mui/icons-material";
import HistoryIcon from "@mui/icons-material/History";
import { grey } from "@mui/material/colors";

function LohnartenMobileUebersicht(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [expanded, setExpanded] = useState([]);
  //Standardfelder
  const loadIndex = useRef(-1);
  const [formular, setFormular] = useState(0);
  const [ladenFormular, setLadenFormular] = useState(0);
  const [workflow, setWorkflow] = useState(0);
  const [hiddenStatus, setHiddenStatus] = useState([]);
  const [hideFormulare, setHideFormulare] = useState([]);
  const [formularDetailsRow, setFormularDetailsRow] = useState(-1);
  const [selectedFormular, setSelectedFormular] = useState({});
  const [showModal, setShowModal] = useState(false);
  const { monatsErgebnisse, client, accessToken, formularliste, Reload, alleFormulare } = props;
  const boxRef = useRef();

  var isDarkMode = false;
  if (theme.palette.mode === "light") {
    isDarkMode = false;
  } else {
    isDarkMode = true;
  }

  useEffect(() => {
    // init();
    // eslint-disable-next-line
    // console.log(monatsErgebnisse);
  }, []);
  function Bearbeiten(key) {
    setLadenFormular(key);
    loadIndex.current = formularliste.findIndex((p) => p.formular === key.substr(7, 3));
    if (loadIndex.current !== -1) {
    }
    setFormular(key.substr(7, 3));
    setShowModal(true);
  }
  const neuLaden = () => {
    Reload();
    setShowModal(false);
  };
  const hideStatus = (key) => {
    if (hiddenStatus.includes(key)) {
      setHiddenStatus(hiddenStatus.filter((item) => item !== key));
    } else {
      setHiddenStatus([...hiddenStatus, key]);
    }
  };
  return (
    <>
      {monatsErgebnisse?.map((monat) => {
        return (
          <Box p={1} ref={boxRef}>
            <Paper>
              <Box p={1}>
                <Typography align="left" color={"primary"} variant="h4">
                  {monat.monat}
                </Typography>
                <Paper sx={{ mb: 2 }}>
            
                  <Box p={1}>
                    {" "}
                    <div style={{ display: "flex" }}>
                      <Typography variant="h5">Formulare</Typography>{" "}
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={(e) => {
                          if (hideFormulare.includes(monat.monat + "_FORM")) {
                            setHideFormulare(hideFormulare.filter((item) => item !== monat.monat + "_FORM"));
                          } else {
                            setHideFormulare([...hideFormulare, monat.monat + "_FORM"]);
                          }
                        }}
                      >
                        {hideFormulare.includes(monat.monat + "_FORM") ? <VisibilityOff align="center" /> : <Visibility size="small" />}
                      </IconButton>
                    </div>
                  </Box>
                  {!hideFormulare.includes(monat.monat + "_FORM") && (
                    <TableContainer>
                      <Table aria-label="simple table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                position: "sticky",
                                left: 0,
                                zIndex: 900,
                                top: 0,
                              }}
                            >
                              <Typography>Formular</Typography>
                              {[...new Set(monat.formular.map((obj) => obj.status))].map((stat) => {
                                const status = monat.status.find((e) => e.key === stat);
                                const color = status.key === "1" ? "green" : status.key === "G" ? "lightgreen" : status.key === "0" ? "green" : "yellow";
                                return (
                                  <Chip
                                    onClick={() => hideStatus(status.key)}
                                    onDelete={() => hideStatus(status.key)}
                                    deleteIcon={hiddenStatus.includes(status.key) ? <VisibilityOff /> : <Visibility />}
                                    label={status.bez}
                                    style={{ backgroundColor: color }}
                                  ></Chip>
                                );
                              })}
                            </TableCell>
                            {monat.lohnarten?.map((loa) => (
                              <TableCell align="right">
                                <Typography>{loa.bez}</Typography>
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {monat?.formular
                            ?.filter((form) => !hiddenStatus.includes(form.status))
                            .map((formular, index) => {
                              const color =
                                formular.status === "1" ? "green" : formular.status === "G" ? "lightgreen" : formular.status === "0" ? "green" : "yellow";
                              // const loaWerte = monat.summen.find((e) => e.key === loa.key)[status.bez];
                              return (
                                <>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 900,
                                        top: 0,
                                        background: isDarkMode ? theme.palette.grey[900] : "white",
                                      }}
                                    >
                                      <IconButton aria-label="expand row" size="small" onClick={() => Bearbeiten(formular.key)}>
                                        <Visibility />
                                      </IconButton>
                                      <Chip variant="filled" style={{ backgroundColor: color }} label={formular.statusBez}></Chip>
                                      <div>
                                        <Typography align="left" variant="caption">
                                          {formular.bez}
                                        </Typography>
                                      </div>
                                      <div>
                                        <Typography align="left" variant="caption">
                                          {formular.bem}
                                        </Typography>
                                      </div>
                                      <Typography align="left" variant="caption">
                                        {formatDate(formular.vdat, "YYYY-MM-DD", "DD.MM.YYYY")} -{formatDate(formular.bdat, "YYYY-MM-DD", "DD.MM.YYYY")}
                                      </Typography>
                                      <IconButton
                                        aria-label="expand row"
                                        size="small"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          if (index !== formularDetailsRow) {
                                            setFormularDetailsRow(index);
                                            setSelectedFormular({ ...formular, color: color });
                                          } else {
                                            setFormularDetailsRow(-1);
                                          }
                                        }}
                                      >
                                        {formularDetailsRow === index ? <KeyboardArrowUpIcon size="small" /> : <HistoryIcon />}
                                      </IconButton>
                                    </TableCell>
                                    <>
                                      {monat?.lohnarten?.map((loa, count) => {
                                        const loaWerte = formular.lohnarten?.find((e) => e.key === loa.key);
                                        return (
                                          <TableCell sx={{ background: isDarkMode ? theme.palette.grey[900] : "white" }}>
                                            <Typography align="center" fontWeight={600}>
                                              {(loaWerte?.stunden || "0") !== "0" && loaWerte?.stunden + "St."}
                                              {(loaWerte?.tage || "0") !== "0" && loaWerte?.tage + "Tg."}
                                              {(loaWerte?.betrag || "0") !== "0" && loaWerte?.betrag + "€"}
                                            </Typography>
                                          </TableCell>
                                        );
                                      })}
                                    </>
                                  </TableRow>
                                </>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Paper>
                <Paper>
                  <Box p={1}>
                    <Typography variant="h5" align="left">
                      {" "}
                      Lohnarten
                    </Typography>
                  </Box>
                  <TableContainer>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              position: "sticky",
                              left: 0,
                              zIndex: 900,
                              top: 0,
                            }}
                          >
                            Lohnart
                          </TableCell>
                          {monat.status?.map((status) => (
                            <TableCell align="right">{status.bez}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {monat?.lohnarten?.map((loa, count) => {
                          return (
                            <TableRow>
                              <TableCell
                                sx={{
                                  position: "sticky",
                                  left: 0,
                                  zIndex: 900,
                                  top: 0,
                                }}
                              >
                                {loa.bez}
                              </TableCell>
                              {monat.status?.map((status) => {
                                const loaWerte = monat.summen.find((e) => e.key === loa.key)[status.bez];
                                return (
                                  <TableCell>
                                    {" "}
                                    <Typography align="center" fontWeight={600}>
                                      {(loaWerte?.stunden || "0") !== "0" && loaWerte?.stunden + "St."}
                                      {(loaWerte?.tage || "0") !== "0" && loaWerte?.tage + "Tg."}
                                      {(loaWerte?.betrag || "0") !== "0" && loaWerte?.betrag + "€"}
                                    </Typography>
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
            </Paper>
          </Box>
        );
      })}
      <Dialog open={showModal} onClose={setShowModal} maxWidth="false" fullScreen fullWidth>
        <Button
          aria-label="close"
          variant="contained"
          onClick={() => setShowModal(false)}
          sx={{
            marginTop: 5,
          }}
        >
          Abbrechen
        </Button>

        <DialogContent>
          <Box pt={1}>
            <FormularEingabe
              client={client}
              accessToken={accessToken}
              formular={formularliste[loadIndex.current] ? formularliste[loadIndex.current].art + formular : "F" + formular}
              formularkey={ladenFormular}
              Reload={neuLaden}
              noNavigate={true}
              setFormular={setFormular}
              workflow={workflow}
              setFormularkey={setLadenFormular}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button
              style={{ marginRight: "10px" }}
              color="primary"
              variant="contained"
              display="flex"
              onClick={() => { setShowModal(false); setSelectedFile(null); setShare(""); setPersonenID(""); setPersonenNamen("") }}>
              {t("Abbrechen")}
            </Button> */}
        </DialogActions>
      </Dialog>
      <Dialog open={formularDetailsRow !== -1} onClose={() => setFormularDetailsRow(-1)} maxWidth="false" fullScreen fullWidth>
        {/* <Button
          aria-label="close"
            variant="contained"
          onClick={() => setShowModal(false)}
          sx={{            
            marginTop: 5,
          }}
        >
         Abbrechen 
        </Button> */}

        {/* <DialogContent> */}
        <Grid container justifyContent="center" pb={5} pt={5}>
          <Grid item xs={3}></Grid>
          <Grid item xs={6}>
            <Chip
              variant="filled"
              style={{ backgroundColor: selectedFormular.color, alignContent: "center", placeSelf: "center", width: "100%" }}
              align="center "
              label={selectedFormular.statusBez}
            ></Chip>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={12}>
            <Typography align="center">{selectedFormular.bez}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center">{selectedFormular.bem}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center">
              {formatDate(selectedFormular.vdat, "YYYY-MM-DD", "DD.MM.YYYY")} -{formatDate(selectedFormular.bdat, "YYYY-MM-DD", "DD.MM.YYYY")}
            </Typography>
          </Grid>
        </Grid>

        <Typography variant="h6" gutterBottom align="center">
          {t("Verlauf")}
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography fontWeight={530}>Person</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={530}>Aktion</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={530}>Datum</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alleFormulare
              .find((e) => e.key === selectedFormular.key)
              ?.history?.sort((a, b) => a.zeitstempel - b.zeitstempel)
              .map((historyRow) => (
                <TableRow key={historyRow.date}>
                  <TableCell component="th" scope="row">
                    {historyRow.person}
                  </TableCell>
                  <TableCell>{historyRow.aktion}</TableCell>
                  <TableCell>{historyRow.datum}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {/* </DialogContent> */}
        <DialogActions>
          <Button
            style={{ marginRight: "10px" }}
            color="primary"
            variant="contained"
            display="flex"
            onClick={() => {
              setFormularDetailsRow(-1);
            }}
          >
            {t("Abbrechen")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default LohnartenMobileUebersicht;
